import {BatchingBinCacheEntity, ChickenCacheEntity} from "../../manager/DefineInterface";
import {EggEntity, getEggById} from "./config/EggConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import {getChickEntityById} from "./config/ChickConfig";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 * 孵化仓Item
 */
@ccclass
export default class HatchingBinItemNode extends cc.Component {

    @property(cc.Node)
    lockIconNode : cc.Node = null;
    @property(cc.Sprite)
    eggSpirit : cc.Sprite = null;
    @property(cc.SpriteFrame)
    eggSpiritFrame : cc.SpriteFrame[] = [];
    @property(cc.Node)
    videoSpNode : cc.Node = null;
    @property
    mIndex : number = 0;
    @property(sp.Skeleton)
    chicSp : sp.Skeleton = null;
    @property( sp.Skeleton )
    phoenixSp : sp.Skeleton = null;
    @property( sp.Skeleton )
    dragonSp : sp.Skeleton = null;
    @property( sp.Skeleton )
    efBrokeSp : sp.Skeleton = null;
    @property( cc.Node )
    btnGet : cc.Node = null;
    @property(cc.Label)
    lbDownTime : cc.Label = null;

    private mBatchingBinCacheEntity : BatchingBinCacheEntity;
    private mEggEntity : EggEntity;
    private mGameLayer : NormalGameManager;

    onLoad () {
        O1HD.on("HatchingBinItemNode.refreshBtn" , this.refreshBtn , this );
        O1HD.on("HatchingBinItemNode.activeItem" , this.activeItem , this );
        O1HD.on("HatchingBinItemNode.checkEggHatching" , this.checkEggHatching , this );
        O1HD.on("HatchingBinItemNode.setTimerDown" , this.setTimerDown , this );
    }

    start () {
        this.mGameLayer = NormalGameManager._instance;
        this.refreshBtn();
    }

    /**
     * 激活
     */
    activeItem( index : number, batchingBinCacheEntity : BatchingBinCacheEntity ,callback ){
        if ( index == this.mIndex ) {
            this.mGameLayer = NormalGameManager._instance;
            // console.log("activeItem",index,this.mBatchingBinCacheEntity);
            if ( this.mBatchingBinCacheEntity ) {
                callback && callback();
                return;
            }
            this.mBatchingBinCacheEntity = batchingBinCacheEntity;
            this.mEggEntity = getEggById( this.mBatchingBinCacheEntity.eggId );
            this.loadEgg();
        }
    }

    /**
     * 加载鸡蛋
     */
    loadEgg(){
        if ( this.mBatchingBinCacheEntity.chickenId ) {
            this.refreshChicken( this.mBatchingBinCacheEntity.chickenId );
        }else{
            this.eggSpirit.node.active  = true;
            switch ( this.mEggEntity.goodsId ) {
                case 21001:this.eggSpirit.spriteFrame = this.eggSpiritFrame[0];break;
                case 21004:this.eggSpirit.spriteFrame = this.eggSpiritFrame[3];break;
                case 21005:this.eggSpirit.spriteFrame = this.eggSpiritFrame[4];break;
                case 21006:this.eggSpirit.spriteFrame = this.eggSpiritFrame[5];break;
            }
            this.setTimerDown();
        }
    }

    /**
     * 设计倒计时
     */
    setTimerDown(){
        if ( this.mBatchingBinCacheEntity && !this.mBatchingBinCacheEntity.chickenId ) {
            let hour = NormalGameManager._instance.mGameHours - this.mBatchingBinCacheEntity.startGameHour;
            let minute = NormalGameManager._instance.mMinute - this.mBatchingBinCacheEntity.startGameMinute;
            let hasLiveSeconds = data_control.getSeconds( hour , minute );
            // console.log("计时" ,  this.mIndex , this.mBatchingBinCacheEntity , hasLiveSeconds )
            if ( hasLiveSeconds >= this.mEggEntity.hatchingSeconds ) {
                //孵化成功
                this.lbDownTime.node.active = false;
                this.checkEggHatching();
            }else{
                //孵化中
                this.lbDownTime.node.active = true;
                let leftoverSeconds : string = data_control.getTimeFormatClock( this.mEggEntity.hatchingSeconds - hasLiveSeconds );
                this.lbDownTime.string = `${leftoverSeconds}`;
            }
        }
    }

    /**
     * 检查是否孵化
     */
    checkEggHatching(){
        // 孵化
        let weightAll : number = 0;
        // console.log( `checkEggHatching` , this.mEggEntity );
        for ( let hatchingRule of this.mEggEntity.hatchingSpecies ) {
            weightAll += hatchingRule.weight;
        }
        let randomNum = Math.floor( Math.random() * weightAll );
        let chickId : number = null;
        for ( let hatchingRule of this.mEggEntity.hatchingSpecies  ) {
            if ( randomNum <= hatchingRule.weight ) {
                chickId = hatchingRule.chickenId;
                break;
            }
            randomNum -= hatchingRule.weight;
        }

        //蛋 碎表现
        this.eggSpirit.node.active = false;
        this.efBrokeSp.node.active = true;
        let skin = this.mEggEntity.skin;
        this.scheduleOnce(()=>{
            this.efBrokeSp.setSkin(skin);
            this.efBrokeSp.setToSetupPose();
        });
        this.efBrokeSp.setAnimation( 0 , "animation" , false );
        //数据
        this.mBatchingBinCacheEntity.chickenId = chickId;
        this.mGameLayer.writeGameData();
        //孵化失败
        // console.log( `checkEggHatching` , chickId );
        if ( chickId == -1 ) {
            this.scheduleOnce(()=>{
                O1HD.getModules().uiControlModule.showMessageBox("孵化失败");
            },1 );
            let index = NormalGameManager._instance.getGameData().batchingBinData.findIndex(( item,index,dataList )=>{
                return item.uniqueId == this.mBatchingBinCacheEntity.uniqueId;
            });
            NormalGameManager._instance.getGameData().batchingBinData.splice( index , 1 );
            //移除成功
            // console.log("移除成功", this.mIndex );
            this.mBatchingBinCacheEntity = null;
            this.mEggEntity = null;
        }else{
            //鸡出来特效
            this.scheduleOnce(()=>{
                this.refreshChicken( chickId );
            },1.5 );
            //孵化成功
        }
    }

    /**
     * 孵化失败
     */
    hatchingFail(  ){
        this.eggSpirit.node.active = false;
        this.efBrokeSp.node.active = true;
        let skin = this.mEggEntity.skin;
        this.scheduleOnce(()=>{
            this.efBrokeSp.setSkin(skin);
            this.efBrokeSp.setToSetupPose();
        });
        this.efBrokeSp.setAnimation( 0 , "animation" , false );
    }


    /**
     *
     */
    onBtnGet(){
        //表现
        this.chicSp.node.active = false;
        this.phoenixSp.node.active = false;
        this.dragonSp.node.active = false;
        this.btnGet.active = false;
        if ( !this.mBatchingBinCacheEntity ) {
            return;
        }
        //数据 移除
        let findIndex = this.mGameLayer.getGameData().batchingBinData.findIndex((item,index,dataList) => {
           return item.uniqueId == this.mBatchingBinCacheEntity.uniqueId;
        });
        this.mGameLayer.getGameData().batchingBinData.splice( findIndex , 1 );

        //数据 添加
        let currMill = new Date().getTime();
        let chickenCacheEntity : ChickenCacheEntity = {
            bornGameHour: this.mGameLayer.mGameHours,
            bornGameMinute: this.mGameLayer.mMinute,
            chickenId: this.mBatchingBinCacheEntity.chickenId,
            lastLayHour: this.mGameLayer.mGameHours,
            lastLayMinute: this.mGameLayer.mMinute,
            uniqueId: currMill,
        }
        this.mGameLayer.getGameData().chickenData.push( chickenCacheEntity );
        this.mGameLayer.writeGameData();
        O1HD.emit("ChickenPrefab.addChickItemNode" , chickenCacheEntity );

        this.mBatchingBinCacheEntity = null;
        this.mEggEntity = null;
    }

    //刷新鸡表现
    refreshChicken( chickId : number ){
        switch ( chickId ) {
            case -1:
                // 孵化失败的
                this.efBrokeSp.node.active = true;
                this.scheduleOnce(()=>{
                    this.efBrokeSp.setSkin( this.mEggEntity.skin);
                    this.efBrokeSp.setToSetupPose();
                });
                this.efBrokeSp.setCompleteListener(()=>{
                    //数据 移除
                    let findIndex = this.mGameLayer.getGameData().batchingBinData.findIndex((item,index,dataList) => {
                        return item.uniqueId == this.mBatchingBinCacheEntity.uniqueId;
                    });
                    this.mGameLayer.getGameData().batchingBinData.splice( findIndex , 1 );
                    this.mBatchingBinCacheEntity = null;
                    this.mEggEntity = null;
                });
                this.efBrokeSp.setAnimation( 0 , "animation" , false );
                break;
            case 1:this.hatchingYoungChicken(chickId);this.btnGet.active = true;break;
            case 3:this.hatchingYoungChicken(chickId);this.btnGet.active = true;break;
            case 5:this.hatchingYoungChicken(chickId);this.btnGet.active = true;break;
            case 7:this.hatchingYoungChicken(chickId);this.btnGet.active = true;break;
            case 9: {
                this.phoenixSp.node.active = true;
                this.phoenixSp.setCompleteListener(()=>{
                    this.phoenixSp.setCompleteListener(()=>{});
                    this.phoenixSp.setAnimation( 0 ,"Idle" , false );
                });
                this.phoenixSp.setAnimation( 0 ,"Jump" , false );
                this.btnGet.active = true;
                break;
            }
            case 10:{
                this.dragonSp.node.active = true;
                this.dragonSp.setCompleteListener(()=>{
                    this.dragonSp.setCompleteListener(()=>{});
                    this.dragonSp.setAnimation( 0 ,"Idle" , false );
                });
                this.dragonSp.setAnimation( 0 ,"Jump" , false );
                this.btnGet.active = true;
                break;
            }
        }

    }

    /**
     * 小鸡
     */
    hatchingYoungChicken( chickId ){
        this.chicSp.node.active = true;
        this.chicSp.setAnimation( 0 , "Jump" , false );
        this.chicSp.setCompleteListener(()=>{
            this.chicSp.setCompleteListener(()=>{});
            this.chicSp.setAnimation( 0 ,"Idle_01" , false );
        });
        let chickEntity = getChickEntityById( chickId );
        this.scheduleOnce(()=>{
            this.chicSp.setSkin( chickEntity.imgPath );
            this.chicSp.setToSetupPose();
        });
    }


    /**
     * 解锁孵化箱
     */
    onBtnUnlockItem(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            NormalGameManager._instance.getGameData().chickenCoop.batchingBinCount++;
            NormalGameManager._instance.writeGameData();
            O1HD.emit("HatchingBinItemNode.refreshBtn")
        },()=>{

        },()=>{

        },"解锁孵化箱" );
    }

    /**
     * 刷新按钮
     */
    refreshBtn(){
        let actualCount = NormalGameManager._instance.getGameData().chickenCoop.batchingBinCount;
        this.videoSpNode.active = false;
        this.lockIconNode.active = false;
        if ( this.mIndex == actualCount ) {
            this.videoSpNode.active = true;
        }else if ( this.mIndex > actualCount )  {
            this.lockIconNode.active = true;
        }
    }
}
